
export const general = {
  // App name
  appName: 'PlanWiseNow',
  
  // Home page
  homeTitle: 'Take Control of Your Time and Money',
  homeSubtitle: 'The all-in-one platform to manage your personal finances, track habits, set goals, and boost your productivity with intelligent tools.',
  getStarted: 'Get Started',
  
  // Navigation and layout
  home: 'Home',
  dashboard: 'Dashboard',
  today: 'Today',
  todaySummary: 'Overview of important activities and events for today',
  yesterday: 'Yesterday',
  tomorrow: 'Tomorrow',
  
  // Modules
  modules: 'Modules',
  explore: 'Explore',
  
  // Module descriptions
  goals: 'Goals',
  goalsDesc: 'Set and track your personal and professional goals with detailed planning and progress monitoring.',
  blog: 'Blog',
  blogDesc: 'Read articles and tips to improve your productivity, financial management, and personal development.',
  
  // Common actions
  save: 'Save',
  cancel: 'Cancel',
  edit: 'Edit',
  delete: 'Delete',
  add: 'Add',
  create: 'Create',
  update: 'Update',
  close: 'Close',
  open: 'Open',
  confirm: 'Confirm',
  loading: 'Loading...',
  refresh: 'Refresh',
  retry: 'Retry',
  
  // Error messages
  error: 'Error',
  errorLoadingData: 'Error loading data',
  tryAgain: 'Try again',
  loadingTodayData: 'Loading today\'s data...',
  loadingHint: 'If it takes too long, try refreshing',
  problemLoadingData: 'Problem loading data',
  unexpectedError: 'An unexpected error occurred while loading information',
  reloadPage: 'Reload page',
  
  // Success messages
  success: 'Success',
  
  // Empty states
  noData: 'No data available',
  noResults: 'No results found',
  
  // Time-related
  date: 'Date',
  time: 'Time',
  startTime: 'Start time',
  endTime: 'End time',
  
  // General sections
  tasksAndGoals: 'Tasks & Goals',
  calendarAndEvents: 'Calendar & Events',
  financeOverview: 'Finance Overview',
  
  // Task-related
  overdueTasks: 'Overdue Tasks',
  todayTasks: "Today's Tasks",
  todoToday: 'To Do Today',
  noOverdueTasks: 'No overdue tasks',
  noTodayTasks: 'No tasks for today',
  completedTasks: '{completed} of {total} completed',
  addQuickTask: 'Add quick task...',
  allTasks: 'All Tasks',
  quickTasks: 'Quick Tasks',
  noQuickTasks: 'No quick tasks',
  projectTasks: 'Project Tasks',
  markAsComplete: 'Mark as complete',
  events: 'Events',
  completed: 'Completed',
  currentStreak: 'Current Streak',
  bestStreak: 'Best Streak',
  compactView: 'Compact',
  normalView: 'Normal',
  focusedView: 'Focused',
  
  // Calendar-related
  specialDates: 'Special Dates',
  todaySchedule: "Today's Schedule",
  noSpecialDates: 'No special dates today',
  noScheduledEvents: 'No scheduled events',
  
  // Finance-related
  todayPayments: "Today's Payments",
  todayIncome: "Today's Income",
  overdueDebts: 'Overdue Debts',
  todayDebts: "Today's Debts",
  noTodayPayments: 'No payments for today',
  noIncome: 'No income for today',
  noOverdueDebts: 'No overdue debts',
  noTodayDebts: 'No debts due today',
  
  // Reminders-related
  reminders: 'Reminders',
  overdueReminders: 'Overdue Reminders',
  todayReminders: "Today's Reminders",
  upcomingReminders: 'Upcoming Reminders',
  noOverdueReminders: 'No overdue reminders',
  noTodayReminders: 'No reminders for today',
  noUpcomingReminders: 'No upcoming reminders',
  reminderCompleted: 'Reminder completed',
  errorCompletingReminder: 'Error completing reminder',
  
  // Habits-related
  habitsToday: "Today's Habits",
  dailyHabits: 'Daily Habits',
  noHabitsToday: 'No habits for today',
  errorUpdatingHabit: 'Error updating habit',
  
  // Weather-related
  weather: 'Weather',
  loadingWeather: 'Loading weather...',
  weatherNotAvailable: 'Weather not available',
  humidity: 'Humidity',
  windSpeed: 'Wind Speed',
  
  // Stock Market-related
  stockMarket: 'Stock Market',
  loadingStocks: 'Loading stocks...',
  stocksNotAvailable: 'Stocks not available',
  
  // Module names and descriptions
  personalFinance: 'Personal Finance',
  financeDesc: 'Manage your budget, track expenses, monitor debts, and achieve your financial goals.',
  taskManagement: 'Task Management',
  taskDesc: 'Organize your tasks, set priorities, and track your productivity.',
  timeManagement: 'Time Management',
  timeDesc: 'Plan your schedule, manage your time effectively, and boost your productivity.',
  habitTracker: 'Habit Tracker',
  habitsDesc: 'Build positive habits and track your daily progress.',
  personalJournal: 'Personal Journal',
  journalDesc: 'Keep a private journal to reflect on your thoughts and experiences.',
  reminderManagement: 'Reminders',
  
  // Additional features
  tasks: 'Tasks',
  notes: 'Notes',
  lists: 'Lists',
  feedback: 'Feedback',
  products: 'Products',
  cart: 'Cart',
  orders: 'Orders',
  subscription: 'Subscription',
  
  // Why choose section
  whyChoose: 'Why Choose PlanWiseNow?',
  platformHelps: 'Our platform helps you take control of your personal and professional life',
  freeToUse: 'Free to Use',
  freeToUseDesc: 'Start managing your life without any cost. Access essential features completely free.',
  bilingualPlatform: 'Bilingual Platform',
  bilingualPlatformDesc: 'Available in English and Spanish to serve a global community.',
  allInOneSolution: 'All-in-One Solution',
  allInOneSolutionDesc: 'Everything you need in one place: finances, tasks, habits, goals, and more.',
  
  // Admin translations
  administration: 'Administration',
  adminProducts: 'Manage Products',
  adminFeatures: 'Manage Features',
  adminSuggestedHabits: 'Suggested Habits',

  // Main features
  mainFeatures: 'Main features',

  // Landing page translations
  welcomeTo: 'Welcome to',
  landingSubtitle: 'The all-in-one platform you need to organize your life, manage your time and achieve your goals efficiently.',
  personalProductivityAssistant: 'Your personal productivity assistant',
  signIn: 'Sign In',
  createFreeAccount: 'Create Free Account',
  alreadyHaveAccount: 'Already have an account',
  
  // Stats
  landingModules: 'Modules',
  landingCategories: 'Categories', 
  possibilities: 'Possibilities',
  
  // Modules section
  allToolsYouNeed: 'All the tools you need',
  completeEcosystem: 'A complete productivity ecosystem designed to adapt to your lifestyle',
  
  // Module titles and descriptions
  todayView: 'Today View',
  todayViewDesc: 'Personalized dashboard with daily summary',
   landingTaskManagement: 'Task Management',
  taskManagementDesc: 'Organize and prioritize your tasks with the Eisenhower matrix',
   landingTimeManagement: 'Time Management',
  timeManagementDesc: 'Integrated Pomodoro technique to maximize your productivity',
   landingReminders: 'Reminders',
  remindersDesc: 'Never forget important tasks with smart reminders',
  quickNotes: 'Quick Notes',
  quickNotesDesc: 'Capture ideas and important information instantly',
  listsChecklists: 'Lists & Checklists',
  listsChecklistsDesc: 'Create organized lists for any purpose',
  habitTracking: 'Habit Tracking',
  habitTrackingDesc: 'Build positive habits and maintain tracking',
  goalsObjectives: 'Goals & Objectives',
  goalsObjectivesDesc: 'Define, plan and achieve your long-term objectives',
  personalDiary: 'Personal Diary',
  personalDiaryDesc: 'Reflect and document your personal growth',
  financeControl: 'Finance Control',
  financeControlDesc: 'Manage budgets, investments and net worth',
  ideasProjects: 'Ideas & Projects',
  ideasProjectsDesc: 'Capture and develop creative ideas in a kanban',
  blogArticles: 'Blog with Articles',
  blogArticlesDesc: 'Share knowledge and experiences through articles',
  youtubeChannel: 'YouTube Channel PlanWiseNow',
  youtubeChannelDesc: 'Exclusive content and productivity tutorials',
  
  // Categories
  landingProductivity: 'Productivity',
  personalDevelopment: 'Personal Development',
  landingFinance: 'Finance',
  organization: 'Organization',
  creativity: 'Creativity',
  
  // Features
  dailySummary: 'Daily summary',
  pendingTasks: 'Pending tasks',
  landingHabits: 'Habits',
   landingWeather: 'Weather',
  eisenhowerMatrix: 'Eisenhower Matrix',
  subtasks: 'Subtasks',
  deadlines: 'Deadlines',
  pomodoroTimer: 'Pomodoro Timer',
  statistics: 'Statistics',
  breaks: 'Breaks',
  sessions: 'Sessions',
  flexibleDates: 'Flexible dates',
  repetition: 'Repetition',
  notifications: 'Notifications',
  priorities: 'Priorities',
  richEditing: 'Rich editing',
  tags: 'Tags',
  search: 'Search',
  dragDrop: 'Drag & drop',
  templates: 'Templates',
  progress: 'Progress',
  dailyTracker: 'Daily tracker',
  streaks: 'Streaks',
  smartPlanning: 'SMART planning',
  milestones: 'Milestones',
  analysis: 'Analysis',
  privateEntries: 'Private entries',
  moodAnalysis: 'Mood analysis',
  themes: 'Themes',
  encryption: 'Encryption',
  budgets: 'Budgets',
  investments: 'Investments',
  debts: 'Debts',
  netWorth: 'Net worth',
  kanbanBoard: 'Kanban board',
  ideaEvolution: 'Idea evolution',
  resources: 'Resources',
  states: 'States',
  videoTutorials: 'Video tutorials',
  weeklyTips: 'Weekly tips',
  useCases: 'Use cases',
  community: 'Community',
  
  // Why choose section
  readyToTransform: 'Ready to transform your productivity?',
  joinThousands: 'Join thousands of users who are already achieving their goals with PlanWiseNow.',
  startFreeNow: 'Start Free Now',
  
  // Features highlight
  securePrivate: 'Secure & Private',
  securePrivateDesc: 'Your data is protected with military-grade encryption and strict privacy policies.',
  continuousImprovement: 'Continuous Improvement',
  continuousImprovementDesc: 'Detailed analytics and statistics to help you constantly improve your productivity.',
  easyToUse: 'Easy to Use',
  easyToUseDesc: 'Intuitive interface and elegant design that adapts to your natural workflow.',
  
  // Footer
  landingPersonalAssistant: 'Your personal assistant for a more organized and productive life.',
  
  // Important Data module
  importantDataModule: 'Important Data',
  importantDataDescription: 'Store and protect your most sensitive data with encryption',
  
  // Documents module
  documents: 'Documents',
  documentsDescription: 'Create, edit and manage text documents with rich formatting and PDF export',
  wordProcessor: 'Text Processor',
  pdfViewer: 'PDF Viewer',
  
  // Features highlights
  dailyEntries: 'Daily entries',
  moodTracking: 'Mood tracking',
  textEditor: 'Text editor',
  advancedSearch: 'Advanced search',
  scheduledReminders: 'Scheduled reminders',
  calendarIntegration: 'Calendar integration',
  shareFiles: 'Share files',
  documentsManagement: 'Documents Management',
  documentsManagementDesc: 'Organize, view and share PDF documents with advanced tools',
  
  // Additional modules
  moreToolsIncluded: 'More tools included',
  
  // Premium features
  premiumFeatures: 'Premium Features',
  aiAssistant: 'AI Assistant',
  aiAssistantDesc: 'Intelligent assistant to boost your productivity',
  automation: 'Automation',
  automationDesc: 'Automate repetitive tasks and workflows',
  advancedReports: 'Advanced Reports',
  advancedReportsDesc: 'Detailed analytics and productivity metrics',
  teamCollaboration: 'Team Collaboration',
  teamCollaborationDesc: 'Advanced functions for teamwork',
  premium: 'Premium',
  
  // Counter
  of: 'of',
  
  // Sidebar modules
  productivityCenter: 'Productivity Center',
  integrations: 'Integrations',
  store: 'Store',
  financialEducation: 'Financial Education',
  productivityEducation: 'Productivity Education',
};
